export default __webpack_public_path__ + "2956dc4a0d29e9bdf81e55ec0e1e9fee.png";